import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import {
  FormViewService,
  IntegrationMappingService,
} from '@xilo-mono/form-contracts';
import { changeInputCSS } from '../helper/form';
import { removeMoneyFormatting } from '@xilo-mono/form-helper';

@Component({
  selector: 'xilo-mono-form-viewer-currency',
  templateUrl: './currency.component.html',
  styleUrls: ['../../form-viewer.component.scss', './currency.component.scss'],
})
export class CurrencyComponent extends FieldType {
  isInvalid = false;
  errorMessage = false;
  changeInputCSS = changeInputCSS;
  currencyOptions = {
    align: 'left',
    precision: 0,
  };

  constructor(
    private integrationMappingService: IntegrationMappingService,
    private formViewService: FormViewService
  ) {
    super();
  }

  updateMetadata(event: Event) {
    try {
      const target = event.target as HTMLInputElement;
  
      if (target?.value) {
        const trimmedValue = removeMoneyFormatting(target.value.trim());
        this.formControl.setValue(trimmedValue);
  
        if (this.to.className !== 'xilo-input') {
          this.formViewService.updateForm.next(true);
        }
        this.integrationMappingService.initDataPull(
          this.to?.pullDataTrigger,
          this.to?.dataPullMappingId,
          this.field?.parent?.parent?.templateOptions?.subIndex
        );
      }
    } catch (error) {
      console.log(error);
    }
  }

  getError() {
    return 'This value should be 10 numbers.';
  }
}
